import axios from "axios";

// Shared Axios instance for the entire frontend
// For now we don't hard‑set baseURL so existing code can keep using
// different REACT_APP_* base URLs per domain (auth, core API, etc.).
// We only centralise cross‑cutting concerns like auth headers & errors.

const apiClient = axios.create({
  // You can set a global baseURL later if your APIs share the same root.
  // baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000,
  // Always send cookies (authToken/refreshToken) with requests
  withCredentials: true,
});

// Request interceptor: attach auth token and common headers
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    config.headers = {
      Accept: "application/json",
      "Content-Type":
        config.headers && config.headers["Content-Type"]
          ? config.headers["Content-Type"]
          : "application/json",
      ...config.headers,
    };
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: centralise success/error handling
apiClient.interceptors.response.use(
  (response) => {
    // You can normalise responses here if you want:
    // e.g. always return response.data
    return response;
  },
  (error) => {
    // Global error handling hook
    const status = error?.response?.status;

    // Example: handle unauthorised responses in one place
    if (status === 401 || status === 403) {
      console.warn("apiClient received unauthorized response", status);
      // Later you can plug in logout / token refresh / redirect to login here
    }

    return Promise.reject(error);
  }
);

export default apiClient;


